import { ErrorMessage } from "@/model/ErrorMessage";
import { ref } from "vue";

export default class GlobalData {
  constructor() {}

  private static instance: GlobalData = new GlobalData();

  public static getInstance(): GlobalData {
    return GlobalData.instance;
  }

  public changeBackgroundPosition: any = null;
  public batchNoteAdded = ref(false);
  public hasErrorPage = false;
  public errorMessage: ErrorMessage = new ErrorMessage();
  public canAccessError = false;
}
